export default __webpack_public_path__ + "static/media/nosotros.c568df95.jpg";